<div class="attendance-import-container">
  <mat-card>
    <mat-card-header>
      <mat-card-title>
        <mat-icon>upload_file</mat-icon>
        Import Attendance from NgTeco Excel/CSV
      </mat-card-title>
      <mat-card-subtitle>
        Upload a NgTeco timecard report to import attendance records. The system will match Person ID to employees and skip duplicates.
      </mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="import-section">
        <div class="file-upload-area">
          <input 
            type="file" 
            accept=".xlsx,.csv" 
            (change)="onFileSelected($event)"
            [disabled]="loading"
            #fileInput
          />
          <p class="file-hint">Supported formats: .xlsx, .csv</p>
        </div>
        
        <div *ngIf="loading" class="loading-section">
          <mat-spinner diameter="40"></mat-spinner>
          <p>Processing file and importing records...</p>
        </div>
        
        <div *ngIf="importSummary" class="import-summary">
          <mat-icon [class.success]="importSummary.includes('Successfully')" [class.error]="importSummary.includes('failed')">
            {{ importSummary.includes('Successfully') ? 'check_circle' : importSummary.includes('failed') ? 'error' : 'info' }}
          </mat-icon>
          <span>{{ importSummary }}</span>
        </div>
        
        <div *ngIf="importedRecords.length > 0" class="preview-section">
          <h3>Preview (first 10 records):</h3>
          <p class="record-count">Found {{ importedRecords.length }} valid records to import</p>
          <table class="preview-table">
            <thead>
              <tr>
                <th>Person ID</th>
                <th>Date</th>
                <th>Time</th>
                <th>Status</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let rec of importedRecords.slice(0, 10)">
                <td>{{ rec.personId }}</td>
                <td>{{ rec.date }}</td>
                <td>{{ rec.time }}</td>
                <td>{{ rec.status }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </mat-card-content>
  </mat-card>
</div> 